import { render, staticRenderFns } from "./work-order-tasks.html?vue&type=template&id=94b77baa&scoped=true&"
import script from "./work-order-tasks.js?vue&type=script&lang=js&"
export * from "./work-order-tasks.js?vue&type=script&lang=js&"
import style0 from "./WorkOrderTasks.vue?vue&type=style&index=0&id=94b77baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b77baa",
  null
  
)

export default component.exports